/*
 * Hours Table Container
 */

import { connect } from 'react-redux';
import orderBy from 'lodash/orderBy';
import filter from 'lodash/filter';
import { IinitialState } from '../../reducers';
import moment from 'moment';
import { AddHoursTable } from './AddHoursTable';
import { unstageJobHour, setSelectedJobHourID } from '../../actions/manageJobActions';
import { withTranslation, WithTranslation } from 'react-i18next';
import { selectIsLoading } from '../../reducers/commonReducers';
import { IjobHour } from '../../models';

interface Iprops {
    colorButton?: string;
    disabled?: boolean | undefined;
}

const mapStateToProps = (state: IinitialState, ownProps: Iprops & WithTranslation) => {
    const staged: IjobHour[] = Object.values(state.manageJob.tempJobHours);
    const savedFiltered = filter(state.manageJob.selectedJob.jobHours, {
        isDeleted: false
    });
    const savedOrdered = orderBy(savedFiltered, res => moment.utc(res.createDate).unix(), 'desc');
    return {
        loading: selectIsLoading(state),
        // Staged (unsaved) rows first, then previously-saved rows
        tableData: [...staged, ...savedOrdered],
        stagedIds: Object.keys(state.manageJob.tempJobHours),
        selectedJobHourID: state.manageJob.selectedJobHourID,
        disabled: ownProps.disabled
    };
};

export const AddHoursTableContainer = withTranslation('nsJob')(
    connect(mapStateToProps, {
        unstageJobHour,
        setSelectedJobHourID
    })(AddHoursTable)
);
